exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-wrapper .tv-container .tv-item {\n  max-width: 280px;\n  margin: 10px;\n}\n.form-wrapper .tv-container .tv-item .thumb-box.item-selector {\n  min-height: 340px;\n}\n.form-wrapper .tv-container .tv-item .thumb-box.item-selector article div {\n  overflow: hidden;\n  height: 140px;\n  margin-bottom: 10px;\n  padding: 0 1em;\n}\n.form-wrapper .tv-container .tv-item .thumb-box.item-selector article div img {\n  margin-bottom: 0;\n}\n.form-wrapper .tv-container .tv-item .thumb-box.item-selector article div footer {\n  min-height: 3em;\n}", ""]);

// exports
